import React, { Component } from "react";
import { Steps, Button, Icon, Divider, Breadcrumb, Radio, Col, Row, Modal } from "antd";
import { Link, NavLink } from "react-router-dom";
import { Translate } from "react-translated";
import { validationCheck } from "./validation";
import SaveForLaterModal from "./save-for-later-modal";

const Step = Steps.Step;

class WizardSteps extends Component {
  state = {
    show_save_for_later_modal: false,
  }
  // componentDidMount() {
  //   const { wizard, updateField } = this.props;
  //   // validationCheck(wizard,updateField)
  // }

  setFilingStatus(current) {
    const { wizard, updateField, handleBlur } = this.props
    if (wizard && wizard.error && wizard.error.currentIndex[current] === 'error') {
      validationCheck(wizard, updateField, 'filingStatus')
    }
  }

  coverageModal() {
    const { wizard, updateField, handleBlur, complete } = this.props
    if (((wizard.secondary_vehicles_value !== "" && wizard.secondary_vehicles_value !== null) || (wizard.home_market_value !== "" && wizard.home_market_value !== null)) && wizard.coverage !== true) {
      Modal.info({
        title: 'Calculate Coverage',
        content: "To proceed forward, please click on the Calculate Coverage button.",
        okText: 'Calculate Coverage',
        onOk: () => {
          complete();
          updateField("coverage", true)
          updateField("completed_count", 1)
        },
        okButtonProps: {
          className: 'borderRadius-28 bg-164897'
        }
        // onCancel: () => {
        //   updateField("coverage", false)
        // },
      });
    }
  }

  dashboardConfirmation = () => {
    Modal.confirm({
      title: 'All your data will be lost.',
      content: 'Are you sure you want to continue?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        this.props.history.push("/dashboard")
      },
      onCancel: () => {
        // Stay on the current page
      },
    })
  }

  render() {

    const { wizard, updateField, handleBlur, submitStep,
      save,
      prevStep,
      complete,
      user } = this.props;



    let current = 0, pageIndex = 0;
    // if (wizard.stepIndex >= 1 && wizard.stepIndex < 2) current = 1;
    // if (wizard.stepIndex >= 2 && wizard.stepIndex < 4) current = 2;
    // if (wizard.stepIndex >= 4 && wizard.stepIndex < 9) current = 3;
    // if (wizard.stepIndex >= 9 && wizard.stepIndex < 11) current = 4;
    // if (wizard.stepIndex >= 11 && wizard.stepIndex < 13) current = 5;
    // if (wizard.stepIndex === 13) current = 6;
    // if (wizard.stepIndex >= 14 && wizard.stepIndex < 16) current = 7;
    if (wizard.stepIndex === 1) { current = 1, pageIndex = 1 };
    if (wizard.stepIndex === 2) { current = 2, pageIndex = 2 };
    if (wizard.stepIndex === 3) { current = 2, pageIndex = 3 };
    if (wizard.stepIndex === 4) { current = 3, pageIndex = 4 };
    if (wizard.stepIndex === 5) { current = 3, pageIndex = 5 };
    if (wizard.stepIndex === 6) { current = 3, pageIndex = 6 };
    if (wizard.stepIndex === 7) { current = 3, pageIndex = 7 };
    if (wizard.stepIndex === 8) { current = 3, pageIndex = 8 };
    if (wizard.stepIndex >= 9 && wizard.stepIndex < 11) { current = 4, pageIndex = 9 };
    if (wizard.stepIndex >= 11 && wizard.stepIndex < 13) { current = 5, pageIndex = 9 };
    if (wizard.stepIndex === 13) { current = 6, pageIndex = 10 };

    let statusclassname = {}
    if (wizard && wizard.error && wizard.error.currentIndex) {
      statusclassname = { ...wizard.error.currentIndex };
      Array(7).fill("").forEach(((e, i) => {
        if (!statusclassname[i + 1] && (i < current)) {
          statusclassname[i + 1] = 'error'
        }
      }))

      if (!wizard.error.currentIndex[1] && current < 1) {
        statusclassname[1] = "filing"
      }
      if (!wizard.error.currentIndex[current]) {
        statusclassname[current] = 'filing'
      }
    } else
      statusclassname[1] = "filing"


    /**
     * Intro Script
     * Vehicles
     * Children
     * Primary Home
     * Mortgage
     * Secondary Properties
     * Secondary Properties Mortgage
     * Personal Property
     * Protecting What You "Earn"
     * Mortgage
     * Protecting What You "Earn"
     * Recommended Liability Limits
     */

    const stepinfo = {
      1: { name: "Intro", width: 400 },
      2: { name: "Vehicles", width: 350 },
      3: { name: "Children", width: 350 },
      4: { name: 'Primary Home', width: 420 },
      5: { name: 'Mortgage', width: 380 },
      6: { name: 'Secondary Properties', width: 500 },
      7: { name: 'Secondary Property Mortgage', width: 610 },
      8: { name: 'Personal Property', width: 450 },
      9: { name: `Protecting What You "Earn"`, width: 570 },
      10: {
        name: this.props.isExternalBFile ? 'Thank you for Submitting!' :
          'Recommended Liability Limits',
        width: 610
      }
    }




    return (
      <div className="hide-print">

        {/* Breadcrumb */}
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item ><a onClick={this.dashboardConfirmation}>Dashboard</a></Breadcrumb.Item>
          <Breadcrumb.Item>
            Intelligence Link Calculator
          </Breadcrumb.Item>
        </Breadcrumb> */}

        {// `Back to Profile` button will not visible to user If comes from Quick "FollowUp Call" BFile Profile Action
          !wizard.isQuickFollowUpCallFromBFileAction &&
            wizard.id &&
            wizard.id !== "" &&
            !this.props.isExternalBFile ? (
            <div>
              <NavLink to={{ pathname: "/customer/" + wizard.id, state: { ...this.props.history.location.state } }}>
                <Button type="link" style={{ color: "#164897", marginTop: "10px" }} shape="round">
                  <Icon type="arrow-left" />{" "}
                  <Translate text={`Return to Profile`} />
                </Button>
              </NavLink>
            </div>
          ) : null}

        <Row  >
          <Col xs={24} md={12}  
          span={12}
          >
            <img src={require("./images/head.png")} width={stepinfo[pageIndex].width} height={40} className='imgHead' />
            <Row>
              {
                !this.props.isExternalBFile && (
                  <div style={{
                    width: "fit-content", height: 30, backgroundColor: "rgba(202,220,249,0.58)", borderRadius: 9, marginTop: -33,
                    position: "absolute",
                    padding: "5px 10px 5px 10px",
                    marginLeft: 20
                  }}>
                    <p style={{ fontSize: "calc(12px + (0.2vw - 0.12px))", fontWeight: "bold", color: "#164897", textAlign: "center" }}>{wizard.status === 'Renewal' ? "Existing Customer" : "New Customer"}</p>
                  </div>
                )
              }
              <p className="step-info-title"
                style={{ marginLeft: !this.props.isExternalBFile ? 180 : 30, }}>
                {stepinfo[pageIndex].name}
              </p>
            </Row>
          </Col>
          {
            !this.props.isExternalBFile && (
              <Col 
              xs={24} md={12}
              span={12} 
              style={{ display: 'flex', justifyContent: 'flex-end', ...(current !== 1 ? { marginTop: 20 } : {}) }}>
                {current === 1 && <Radio.Group
                  style={{ fontSize: "calc(14px + (0.2vw - 0.14px))" }}
                  value={wizard.status}
                  onChange={(e) => updateField("status", e.target.value)}
                  className='right tabButtons margin-top-0'>
                  <Radio.Button className={wizard.status === 'New B File' ? 'active' : ""} value="New B File"><Icon type="user-add" />  New Customer</Radio.Button>
                  <Radio.Button className={wizard.status === 'Renewal' ? 'active' : ""} value="Renewal"><Icon type="user" /> Existing Customer</Radio.Button>
                </Radio.Group>}

                {/* {current !== 1 && (wizard.isQuickFollowUpCallFromBFileAction &&
                  !wizard.id ||
                  wizard.id === "") && <Button onClick={() =>
                    this.setState({ show_save_for_later_modal: true })
                  }
                    type="primary" shape="round" className='buttonSaveForLater'>
                    Save For Later
                  </Button>} */}
              </Col>
            )
          }
          <SaveForLaterModal
            showModal={this.state.show_save_for_later_modal}
            hideModal={() =>
              this.setState({ show_save_for_later_modal: false })
            }
            wizard={wizard}
            updateField={updateField}
            save={save}
            user={user}
            history={this.props.history}

          />
        </Row>

        {!(wizard.stepIndex == 13 &&
          this.props.isExternalBFile) && (
            <div id="stepspanel"  >
              {/* {[
          {name:"Personal",id:1,active:true,status:""},
          {name:"Auto",id:1,active:null,status:""},
          {name:"Home",id:1,active:null,status:""},
          {name:"Employment",id:1,active:null,status:""},
          {name:"Financial",id:1,active:null,status:""},
          {name:"Libility",id:1,active:null,status:""}]} */}

              <div onClick={() => {
                updateField("gotoStepIndex", 1)
                this.setFilingStatus(1)
              }} className="stepdetails">
                <div className={`count ${statusclassname[1]}`}> {statusclassname[1] === 'filled' ? <Icon type="check" /> : 1}</div>
                <h4 className="fs-small">Personal</h4>
              </div>
              <div className={`divider-horizontal ${statusclassname[2]} `} />
              <div onClick={() => {
                updateField("gotoStepIndex", 2)
                this.setFilingStatus(2)
              }} className="stepdetails">
                <div className={`count ${statusclassname[2]}`}> {statusclassname[2] === 'filled' ? <Icon type="check" /> : 2}</div>
                <h4 className="fs-small">Auto</h4>
              </div>
              <div className={`divider-horizontal ${statusclassname[3]} `} />
              <div onClick={() => {
                updateField("gotoStepIndex", 4)
                this.setFilingStatus(3)
              }} className="stepdetails">
                <div className={`count ${statusclassname[3]}`}> {statusclassname[3] === 'filled' ? <Icon type="check" /> : 3}</div>
                <h4 className="fs-small">Home</h4>
              </div>
              <div className={`divider-horizontal ${statusclassname[4]} `} />
              <div onClick={() => {
                updateField("gotoStepIndex", 9)
                this.setFilingStatus(4)
              }} className="stepdetails">
                <div className={`count ${statusclassname[4]}`}> {statusclassname[4] === 'filled' ? <Icon type="check" /> : 4}</div>
                <h4 className="fs-small">Employment</h4>
              </div>
              <div className={`divider-horizontal ${statusclassname[5]} `} />
              <div onClick={() => {
                updateField("gotoStepIndex", 11)
                this.setFilingStatus(5)
              }} className="stepdetails">
                <div className={`count ${statusclassname[5]}`}> {statusclassname[5] === 'filled' ? <Icon type="check" /> : 5}</div>
                <h4 className="fs-small">Financial</h4>
              </div>

              {
                !this.props.isExternalBFile && (
                  <div className={`divider-horizontal ${statusclassname[6]} `} />
                )}

              {
                !this.props.isExternalBFile && (
                  <div onClick={() => {
                    updateField("gotoStepIndex", 13)
                    this.setFilingStatus(6)
                    this.coverageModal()
                  }} className="stepdetails">
                    <div className={`count ${statusclassname[6]}`}> {statusclassname[6] === 'filled' ? <Icon type="check" /> : 6}</div>
                    <h4 className="fs-small">Liability</h4>
                  </div>
                )
              }

              {/* <Steps current={current}>
            <Step className="stepscount"
              title={<Translate text={`Personal`} />}
              onClick={() => updateField("gotoStepIndex", 1)}
            />
            <Step  className="stepscount"
              title={<Translate text={`Auto`} />}
              onClick={() => updateField("gotoStepIndex", 2)}
            />
            <Step  className="stepscount"
              title={<Translate text={`Home`} />}
              onClick={() => updateField("gotoStepIndex", 4)}
            />
            <Step  className="stepscount"
              title={<Translate text={`Employment`} />}
              onClick={() => updateField("gotoStepIndex", 9)}
            />
            <Step  className="stepscount"
              title={<Translate text={`Financial`} />}
              onClick={() => updateField("gotoStepIndex", 11)}
            />
            <Step  
              title={<Translate text={`Liability`} />}
              className=" stepscount"
              onClick={() => updateField("gotoStepIndex", 13)}
            />
          
          </Steps> */}
            </div>
          )}
      </div>
    );
  }
}

export default WizardSteps;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/steps.js